const resolveApiBaseUrl = (apiBase: string | undefined, currentOrigin: string): URL => {
  if (apiBase && apiBase.trim()) {
    const normalized = apiBase.endsWith('/') ? apiBase : `${apiBase}/`;
    return new URL(normalized, currentOrigin);
  }

  return new URL('/api/v1/', currentOrigin);
};

const MAC_DEVICE_ID_PATTERN = /^[0-9A-F]{12}$/;
const REPEATER_ID_MASK = BigInt('0x7fffffff');

const formatRemoteVncRouteDeviceId = (deviceId: string): string => {
  const trimmed = deviceId.trim();
  const compact = trimmed.replace(/[:-]/g, '').toUpperCase();
  if (!MAC_DEVICE_ID_PATTERN.test(compact)) {
    return trimmed;
  }

  return compact;
};

const normalizeRemoteVncDeviceId = (deviceId: string): string => {
  const trimmed = deviceId.trim();
  const compact = formatRemoteVncRouteDeviceId(trimmed);
  if (!MAC_DEVICE_ID_PATTERN.test(compact)) {
    return trimmed;
  }

  try {
    return (BigInt(`0x${compact}`) & REPEATER_ID_MASK).toString(10);
  } catch (_error) {
    return trimmed;
  }
};

export const buildRemoteVncWebSocketUrl = (
  deviceId: string,
  apiBase: string | undefined = process.env.REACT_APP_LOTTO_API_BASE_URL,
  currentOrigin: string = window.location.origin,
  viewerMetadata?: {
    viewerInstanceId?: string;
    pageLoadedAtMs?: number;
  },
): string => {
  const resolved = resolveApiBaseUrl(apiBase, currentOrigin);
  const basePath = resolved.pathname.endsWith('/') ? resolved.pathname : `${resolved.pathname}/`;
  const normalizedDeviceId = normalizeRemoteVncDeviceId(deviceId);

  resolved.pathname = `${basePath}remote-vnc/ws/${encodeURIComponent(normalizedDeviceId)}`;
  resolved.search = '';
  resolved.hash = '';
  resolved.protocol = resolved.protocol === 'https:' ? 'wss:' : 'ws:';
  if (viewerMetadata?.viewerInstanceId) {
    resolved.searchParams.set('viewer_instance_id', viewerMetadata.viewerInstanceId);
  }
  if (typeof viewerMetadata?.pageLoadedAtMs === 'number' && Number.isFinite(viewerMetadata.pageLoadedAtMs)) {
    resolved.searchParams.set('page_loaded_at_ms', String(Math.trunc(viewerMetadata.pageLoadedAtMs)));
  }

  return resolved.toString();
};

export { formatRemoteVncRouteDeviceId, normalizeRemoteVncDeviceId };
